module.exports = __webpack_public_path__ + "img/l-icon.3f8a9610.svg";